import React from 'react';
import { useLanguage } from '../../contexts/LanguageContext';
import { COLORS } from '../../constants';
import Reveal from '../Reveal';

const STEPS = [['s1', COLORS.pink], ['s2', COLORS.green], ['s3', COLORS.blue]];

const HowItWorks = () => {
  const { t } = useLanguage();

  return (
    <section className="section" data-testid="how-section">
      <div className="section-inner">
        <Reveal className="section-head">
          <span className="eyebrow">{t('home.how.eyebrow')}</span>
          <h2 className="section-title">{t('home.how.title')}</h2>
        </Reveal>

        <div className="steps">
          {STEPS.map(([key, color], i) => (
            <Reveal key={key} delay={i * 0.12}>
              <article className="step-card" style={{ '--line': color }} data-testid={`step-${i + 1}`}>
                <span className="step-num">{i + 1}</span>
                <h3>{t(`home.how.${key}.title`)}</h3>
                <p>{t(`home.how.${key}.desc`)}</p>
              </article>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.2} className="how-cta">
          <button onClick={() => document.getElementById('kit-mixer')?.scrollIntoView({ behavior: 'smooth', block: 'start' })} className="btn-pill btn-pill-primary" data-testid="how-cta-mix">
            {t('home.how.cta')}
          </button>
        </Reveal>
      </div>
    </section>
  );
};

export default HowItWorks;
